module.exports = __webpack_public_path__ + "img/pix.6eb4539d.png";